// @flow
import React from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import Skeleton from 'react-loading-skeleton';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import api from 'utils/API';
import styles from './Post.styles.js';
import navigation from 'app/redux/actions/navigation';
import PostDetails from 'app/components/PostDetails';
import PostComments from 'app/components/PostComments';
import PostCommentForm from 'app/components/PostCommentForm';
import PostRelated from 'app/components/PostRelated';
import PostHashtags from 'app/components/PostHashtags';
import PostActions from 'app/components/PostActions';
import WidgetYektanet from 'app/components/WidgetYektanet';
import Image from 'app/components/Image';
import {PhotoSwipe} from 'react-photoswipe';
import {hasPermission} from 'utils/CurrentUser';
import {scrollTo} from 'utils/Helper';
// import initData from 'app/redux/actions/initData';
import 'react-photoswipe/lib/photoswipe.css';

type Props = {
  value: any,
  slug: String,
  goto: any,
};

type State = {
  redirectTo?: any,
  data: any,
  meta: any,
  gallery: any,
};

class Post extends React.Component<Props, State> {

  unmounted = false;
  DEFAULT_DATA = {
    category: [{}],
    redirectTo: null
  };
  defaultData = this.DEFAULT_DATA;
  contentRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: this.DEFAULT_DATA,
      meta: {},
      gallery: {isOpen: false, items: []}
    };
  }

  fetchPage = () => {
    // const data = {page, count, id: this.props.category};
    const url = `/${this.props.slug}`;
    api.get(url)
    .then(response => {
      if (this.unmounted) {
        return;
      }

      const data = response.data;
      if (data.init_data) {
      }
      // this.props.dispatch(initData(data.init_data));
      this.setState({
        data: data.model || this.DEFAULT_DATA,
        meta: {
          title: data.g_title,
          description: data.g_description,
          canonicalUrl: data.g_canonical_url,
          nextUrl: data.g_next_url,
          prevUrl: data.g_prev_url,
          ogTitle: data.og_title,
          ogType: data.og_type,
          ogDescription: data.og_description,
          ogUrl: data.og_url,
          ogArticleSsection: data.og_article_section,
          ogSiteName: data.og_site_name,
          ogImage: data.og_image
        }
      });
    })
    .catch(error => {
      const response = error.response || {};
      if (response.status === 404) {
        this.setState({redirectTo: '/404'});
      }
    });
  }

  componentDidMount() {
    this.fetchPage();
    this.isAdmin = hasPermission(this.props.permissions.v_posts_edit_post);
  }

  componentDidUpdate(prevProps, prevState) {
    const postData = this.state.data;
    const prevPostData = prevState.data;

    if (prevProps.slug !== this.props.slug) {
      this.setState({data: this.defaultData});
      this.fetchPage();
    }

    // Dispatch new navigation data
    const postCategory = (postData.category && postData.category[0]) || {};
    const prevPostCategory = (prevPostData.category && prevPostData.category[0]) || {};
    if (postCategory.slug && prevPostCategory.slug !== postCategory.slug) {
      const navigationData = {
        category: {
          slug: postCategory.slug,
          id: postCategory.id,
        },
        title: postData.title,
        meta: this.state.meta
        // description: this.state.meta.description,
        // canonicalUrl: this.state.meta.canonicalUrl,
        // openGraph: {
        //   title: this.state.meta.,
        //   type,
        //   description,
        //   url,
        //   site_name,
        //   image,
        // },
      };
      this.props.dispatch(navigation(navigationData));
    }
    //

    if (prevState.data.content !== postData.content && postData.content) {
      // console.log(this.props.goto);
      if (this.props.goto) {
        // const toId = this.props.goto === 'comments' ?
        //   '#post-comments-wrapper' : `.post-${this.props.goto}`;
        scrollTo('#post-comments-wrapper');
      }

      this.initGallery();
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.props.dispatch(navigation({category: {}}));
  }

  initGallery = () => {
    if (!this.contentRef.current) {
      return;
    }

    const contentDOM = this.contentRef.current.childNodes;
    let listDOM;
    for (let i = 0; i < contentDOM.length; i++) {
      if (contentDOM[i].className === 'widget-gallery list') {
        listDOM = contentDOM[i];
      }
    }
    if (!listDOM) {
      return;
    }

    const galleryItems = listDOM.getElementsByClassName('gallery-item');

    // const galleryLinks = listDOM.getElementsByTagName('a');
    // for (let i = galleryLinks.length - 1; i >= 0; i--) {
    //   galleryLinks[i].onclick = (e) => e.preventDefault();
    // }

    let items = [];
    for (let i = 0; i < galleryItems.length; i++) {
      const galleryItem = galleryItems[i];

      const itemLink = galleryItem.getElementsByTagName('a')[0];
      const size = itemLink.getAttribute('data-size').split('x');
      itemLink.onclick = (e) => e.preventDefault();

      items = [...items, {
        src: itemLink.href, 
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
        title: itemLink.text
      }];
      galleryItems[i].onclick = (e) => {
        this.setState({
          gallery: {
            ...this.state.gallery,
            isOpen: true,
            options: {
              ...this.state.gallery.options,
              index: i
            }
          }
        });
      }
    }
  
    let isOpen = false;

    let options = {index: 1};
     
    const handleClose = () => {
      return {isOpen: false}
    };

    this.setState({
      gallery: {
        isOpen, items, options, handleClose
      }
    });
  }

  getThumbnailContent = (item) => {
    const alt = this.state.data.title || '';
    return (
      <img src={item.thumbnail} width={120} height={90} alt={alt} />
    );
  }

  render() {

    if (this.state.redirectTo) {
      return <Redirect to={this.state.redirectTo} />
    }

    const {classes} = this.props;
    const postData = this.state.data;
    const gallery = this.state.gallery;
    const category = (postData.category && postData.category[0]) || {};

    return (
      <React.Fragment>
        <Paper elevation={1} className={classes.wrapper}>
          <article className={classes.container} ref="content">
            <header>
              <Typography component="h4" variant="h4" className={classes.overTitle}>
                {postData.over_title}
              </Typography>
              <Typography component="h1" variant="h1" className={classes.title}>
                {postData.title || <Skeleton count={2} />}
              </Typography>
            </header>
            
            <Grid container className={classes.contentDetailsWrapper}>
              <Grid item md={9} xs={12} className={classes.mainContentContainer}>
                {(postData.thumbnail && 
                  <Image
                    block fill
                    src={postData.thumbnail}
                    className={{root: classes.imageRoot, image: classes.image}}
                  />) ||
                  <Skeleton height={300} />
                }
                {(postData.content &&
                  <div
                    ref={this.contentRef}
                    className={classes.content}
                    dangerouslySetInnerHTML={{__html: postData.content}}
                  >
                  </div>) || <Skeleton count={15} />
                }
              </Grid>
              <Grid item md={3} xs={12}>
                {(postData.title &&
                  <PostDetails
                    isAdmin={this.isAdmin}
                    data={{
                      category,
                      postId: postData.id,
                      thumbnail: postData.thumbnail,
                      timestamp: postData.publish_at,
                      title: postData.title,
                      excerpt: postData.excerpt,
                      pageShortlink: postData.page_shortlink,
                      commentCount: postData.comment_count,
                      author: postData.author
                    }}
                  />) || <Skeleton count={9} width={150} />
                }
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} className={classes.postActions}>
                <PostActions
                  initData={{
                    postId: postData.id,
                    url: postData.name,
                    likes: postData.like_count,
                    dislikes: postData.dislike_count,
                    comments: false
                  }}
                />
              </Grid>


              <Grid item xs={12}>
                <WidgetYektanet method="banner" idNumber="4980" />
                <PostRelated list={postData.related} />
                {this.isAdmin &&
                  <Grid item xs={12}>
                    <PostHashtags hashtags={postData.hashtag} postId={postData.id} />
                  </Grid>
                }
                <PostComments postId={postData.id} />
                <PostCommentForm postId={postData.id} />
              </Grid>
            </Grid>
          </article>
        </Paper>
        <PhotoSwipe
          isOpen={gallery.isOpen}
          items={gallery.items}
          options={gallery.options}
          onClose={gallery.handleClose}
          thumbnailContent={this.getThumbnailContent}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  metaTags: state.metaTags,
  navigation: state.navigation,
  categoryId: state.navigation.category.id,
  permissions: state.permissions,
  // initData: state.initData
});

const Component = connect(mapStateToProps)(withStyles(styles)(Post));
export {Component as Post};
export default Component;